<template>
    <DefaultLayout>
        <Dialog class="Center">
            <p>Thank you for purchasing HOMEY.EXE.</p>
            
            <div v-if="authenticated" class="Center">
            	<p>You are already logged in. Please continue.</p>
				<Button @onPress="_continue" title="Continue"/>
            </div>
            
            <div v-if="!authenticated" class="Center">
            	<p>To access the program, please log-in with your Athom Account.</p>
				<Button @onPress="_login" title="Login" />
            </div>
            
        </Dialog>
    </DefaultLayout>
</template>

<script>
	import {Component, Vue, Prop} from 'vue-property-decorator';
	import DefaultLayout from '../../layouts/Default';
	import Dialog from '../../components/Dialog';
	import Button from '../../components/Button';
	import {Getter, Action, Mutation} from 'vuex-class';
	import SoundManager from '../../util/soundManager.js';

	@Component({
		components: {
			DefaultLayout,
			Dialog,
			Button,
		},
	})
	export default class ViewLogin extends Vue {
		@Action('api/login') login;
		@Action('api/getLoginUrl') getLoginUrl;
		@Action('api/swapCodeForToken') swapCodeForToken;
		@Action('api/getUser') getUser;
		@Getter('api/authenticated') authenticated;
        @Prop({ type: String}) redirectTo;
        
        mounted() {
	        SoundManager.play('beep1');
        }

        async exchangeCodeForToken(code) {
			try {
				const token = await this.swapCodeForToken({ code });
				await this.login({ token });
				await this.getUser();
			} catch (err) {

				// TODO: handle error better
				console.error('failed to exchange code for token', err)
			}
		}

		async _login() {
			try {
				let loginUrl = await this.getLoginUrl();
				const popupWindow = window.open(loginUrl, 'login', 'width=400,height=600');
				const getUrlInterval = setInterval(async () => {
					const url = popupWindow.location.href;
					if (!(url instanceof Error) && url !== 'about:blank') {
						clearInterval(getUrlInterval);
						await this.exchangeCodeForToken(ViewLogin._getQueryParam('code', url));
						popupWindow.close();
						this._continue();
					}
				}, 250);
			} catch (err) {
				// TODO: handle error better
				return console.log('failed to get loginUrl', err);
			}
		}

		_continue() {
            if (this.redirectTo) {
                this.$router.push(this.redirectTo);
            } else {
                this.$router.push('homeys');
            }
        }

		/**
		 * Checks the url if query parameter 'id' is present.
		 * @param id
		 * @returns {string | null}
		 * @private
		 */
		static _getQueryParam(id, url) {
			url = url || window.location.href;
			id = id.replace(/[[\]]/g, "\\$&");
			const regex = new RegExp("[?&]" + id + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
	}
</script>

<style lang="scss">

</style>